import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { L } from "../../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../../constants/trial";
import { yandexMetrikaParams } from "../../../../analytics/yandexMetrika";
import { LANDING_PRICE_FROM } from "../../HomeLanding/landingSeo";
import { getNicheLanding } from "../../NicheLanding/nicheLandings";
import InlineRegister from "../InlineRegister";
import { NICHE_ORDER, NICHE_PAGES } from "../nicheContent";
import { isAudienceMenuPath, PATHS } from "../nav";
import { PageSeo } from "../seo";
import { FaqList } from "./parts";
import site from "../site.module.css";
import h from "./home.module.css";

const MOCK = "/landing";

function Title({ lines }) {
  return (
    <h2 className={h.h2}>
      {lines.map((line) => (
        <span key={line}>{line}</span>
      ))}
    </h2>
  );
}

function formatRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

export default function NichePage({ nicheId }) {
  const page = NICHE_PAGES[nicheId];
  const seo = getNicheLanding(nicheId);
  const [appTab, setAppTab] = useState(page.appTabs[0].id);
  const tab = page.appTabs.find((t) => t.id === appTab) || page.appTabs[0];
  const { lesson } = page;
  const filled = Math.round((lesson.came / lesson.total) * 100);

  useEffect(() => {
    setAppTab(page.appTabs[0].id);
    if (seo?.metrika) yandexMetrikaParams({ landing: seo.metrika });
  }, [page, seo]);

  return (
    <>
      <PageSeo page={nicheId} faq={page.faq} />

      <section className={`${h.hero} ${h.heroNiche}`}>
        <div className={`${h.wrap} ${h.heroGrid}`}>
          <div>
            <h1>
              <span className={h.pill}>{page.pill}</span>
              {page.heroLines.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </h1>
            <p className={h.heroLead}>{page.heroLead}</p>
            <div className={h.heroActions}>
              <a href="#register" className={`${site.btn} ${site.btnLg}`}>
                Создать клуб бесплатно
              </a>
              <a href="#how" className={h.link}>
                Как это работает ↗
              </a>
            </div>
            <div className={h.sports}>
              {page.sports.map((s) => (
                <span key={s}>{s}</span>
              ))}
            </div>
          </div>

          <div className={h.collage} aria-hidden>
            {page.photos?.hero ? (
              <>
                <div className={h.collagePhoto}>
                  <img
                    src={page.photos.hero}
                    alt=""
                    style={page.photos.heroPos ? { objectPosition: page.photos.heroPos } : undefined}
                  />
                </div>
                <img
                  src={`${MOCK}/mock-brand-club.png`}
                  alt=""
                  className={h.heroPhone}
                />
              </>
            ) : (
              <div className={h.collageArt}>
                <page.icon className={h.collageArtIcon} />
                <img src={`${MOCK}/mock-owner-journal.png`} alt="" />
                <img src={`${MOCK}/mock-client-home.png`} alt="" />
              </div>
            )}
            <div className={`${h.float} ${h.floatStat}`}>
              <small>Посещения за неделю</small>
              <b>
                {page.stat.value}
                <em>↑ {page.stat.delta}</em>
              </b>
              <div className={h.bars}>
                {[52, 60, 45, 78, 66, 90, 100].map((v, i) => (
                  <i key={i} style={{ height: `${v}%` }} />
                ))}
              </div>
            </div>
            <div className={`${h.float} ${h.floatClass}`}>
              <small>{lesson.meta}</small>
              <b>{lesson.title}</b>
              <div className={h.meter}>
                <i style={{ width: `${filled}%` }} />
              </div>
              <div className={h.meterRow}>
                Пришли{" "}
                <span>
                  {lesson.came} из {lesson.total}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={h.strip}>
        <div className={`${h.wrap} ${h.stripGrid}`}>
          {page.strip.map(([Icon, t, d]) => (
            <article key={t} className={h.stripCard}>
              <div className={h.stripIcon}>
                <Icon size={20} />
              </div>
              <h3>{t}</h3>
              <p>{d}</p>
            </article>
          ))}
        </div>
      </div>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>01 / Знакомо?</p>
            <Title lines={page.painsTitle} />
          </div>
          <div className={h.grid3}>
            {page.pains.map(([t, d, fix]) => (
              <article key={t} className={h.card}>
                <h3>{t}</h3>
                <p>{d}</p>
                <span className={h.chip}>✓ {fix}</span>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`} id="how">
        <div className={`${h.wrap} ${h.split}`}>
          {page.photos?.split ? (
            <div className={h.splitPhoto}>
              <img
                src={page.photos.split}
                alt={`${page.navTitle} — тренировка в клубе`}
                loading="lazy"
              />
            </div>
          ) : (
            <div className={h.splitArt} aria-hidden>
              <img src={`${MOCK}/mock-owner-calendar.png`} alt="" />
            </div>
          )}
          <div>
            <p className={h.kicker}>02 / На занятии</p>
            <Title lines={["Тренер отмечает группу.", "Абонемент обновляется сам."]} />
            <p className={h.sub}>{page.classLead}</p>
            <div className={h.facts}>
              {[
                ["Журнал на телефоне", "Открыли занятие и отметили, кто пришёл."],
                ["Списание само", "Занятие ушло с абонемента без таблиц."],
                ["Видно в приложении", "Посещение и остаток сразу у родителя или клиента."],
              ].map(([t, d]) => (
                <div key={t}>
                  <b>{t}</b>
                  <span>{d}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={h.section} id="app">
        <div className={h.wrap}>
          <div className={h.headRow}>
            <div>
              <p className={h.kicker}>03 / Клуб в телефоне</p>
              <Title lines={page.appTitle} />
            </div>
            <div className={h.tabs} role="tablist" aria-label="Экраны приложения">
              {page.appTabs.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  role="tab"
                  aria-selected={t.id === tab.id}
                  className={`${h.tab} ${t.id === tab.id ? h.tabOn : ""}`}
                  onClick={() => setAppTab(t.id)}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          <div className={h.app}>
            <div className={h.appCopy}>
              <h3>
                {tab.title.map((line) => (
                  <span key={line}>{line}</span>
                ))}
              </h3>
              <p>{tab.text}</p>
              <ul>
                {tab.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
              <a href="#register" className={site.btn}>
                Попробовать бесплатно
              </a>
            </div>
            <div className={h.phones} key={tab.id}>
              {tab.screens.map((src, i) => (
                <img
                  key={src}
                  src={`${MOCK}/${src}`}
                  alt={i === 1 ? `Приложение ${L.productName}: ${tab.title.join(" ")}` : ""}
                  className={i === 1 ? h.phoneMain : h.phoneSide}
                  loading="lazy"
                />
              ))}
            </div>
          </div>
          <p className={h.fine}>
            Реальные экраны {L.productName}. {page.appNote}
          </p>
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>04 / Под ваши правила</p>
            <Title lines={page.rulesTitle} />
          </div>
          <div className={h.grid4}>
            {page.rules.map(([Icon, t, d]) => (
              <article key={t} className={h.card}>
                <span className={`${h.audIcon} ${h.principleIcon}`} aria-hidden>
                  <Icon size={22} />
                </span>
                <h3>{t}</h3>
                <p>{d}</p>
              </article>
            ))}
          </div>
          <div className={h.ask}>
            <div>
              <h3>От {formatRub(LANDING_PRICE_FROM)} ₽ в месяц за клуб</h3>
              <p>
                Первые {TRIAL_DAYS} дней — полный доступ бесплатно, без
                привязки карты. Модули подключаются по мере роста.
              </p>
            </div>
            <Link to={PATHS.pricing} className={site.btn}>
              Тарифы и модули
            </Link>
          </div>
        </div>
      </section>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker} id="register">
              05 / Регистрация
            </p>
            <Title lines={page.regTitle} />
            <p className={h.sub}>
              Без заявок и ожидания менеджера. Регистрируетесь сами — и сразу
              заводите группы.
            </p>
          </div>
          <InlineRegister />
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`} id="faq">
        <div className={`${h.wrap} ${h.faqRow}`}>
          <div>
            <p className={h.kicker}>06 / Вопросы и ответы</p>
            <Title lines={["Частые", "вопросы"]} />
            <p className={h.sub}>
              Не нашли ответ? Напишите нам — поможем с запуском и переносом
              базы.
            </p>
            <nav className={h.otherNiches} aria-label="Другие направления">
              {NICHE_ORDER.filter(
                (id) =>
                  id !== nicheId && isAudienceMenuPath(NICHE_PAGES[id].path),
              ).map((id) => {
                const item = NICHE_PAGES[id];
                return (
                  <Link key={id} to={item.path}>
                    {item.navTitle}
                  </Link>
                );
              })}
            </nav>
          </div>
          <FaqList key={nicheId} items={page.faq} />
        </div>
      </section>
    </>
  );
}
